import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    closing: { default: "false", type: String },
    open: { default: "false", type: String },
  }

  connect() {
    this.closeTimeout = null
  }

  disconnect() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }
  }

  // Collapsed content is only clipped by max-height, so inert keeps it out of
  // the tab order and accessibility tree. Also catches direct writes to the
  // open-value attribute that bypass toggle().
  openValueChanged(value) {
    if (this.hasContentTarget) this.contentTarget.inert = value !== "true"
  }

  toggle() {
    const isOpen = this.element.dataset.toggleOpenOpenValue === "true"

    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }

    if (isOpen) {
      this.element.dataset.toggleOpenClosingValue = "true"
      this.element.dataset.toggleOpenOpenValue = "false"

      this.closeTimeout = setTimeout(() => {
        this.element.dataset.toggleOpenClosingValue = "false"
        this.closeTimeout = null
      }, 300)

      return
    }

    this.element.dataset.toggleOpenClosingValue = "false"
    this.element.dataset.toggleOpenOpenValue = "true"
  }
}
